<template>
  <div class="task-list">
    <el-form :inline="true" :model="formInline" label-position="left" @keydown.enter="onSubmit"
      class="demo-form-inline">
      <!-- <el-form-item label="任务类型：">
        <el-select v-model="formInline.pickType" placeholder="全部">
          <el-option label="组合任务" :value="0"></el-option>
          <el-option label="调拨任务" :value="1"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="任务单号：">
        <el-input maxlength='450' v-model="formInline.pickCode" placeholder="输入任务单号" @keydown.native.enter="onSubmit"></el-input>
      </el-form-item>
      <el-form-item label="组合编码：">
        <el-input maxlength='450' v-model="formInline.packCode" placeholder="输入组合编码" @keydown.native.enter="onSubmit"></el-input>
      </el-form-item>
      <el-form-item label="批次包编码：">
        <el-input maxlength='450' v-model="formInline.pkgCode" placeholder="输入批次包编码" @keydown.native.enter="onSubmit"></el-input>
      </el-form-item>
      <el-form-item label="任务状态：">
        <el-select v-model="formInline.status" placeholder="全部">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option label="未完成" :value="0"></el-option>
          <el-option label="已完成" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单编号：">
        <el-input maxlength='50' v-model="formInline.platformOrderNo" placeholder="输入订单编号" @keydown.native.enter="onSubmit"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="restSubmit">重置</el-button>
      </el-form-item>
    </el-form>
    <WmsTable :columns="dataSourceType == 0 ? taskColumns : taskColumns_delivery" @pageChange="pageChangeCall" :dataSource="dataSource" :isPagination="query" 
      :isExpanded="true" :rowKey="dataSourceType == 0?'packCode':'pickCode'" :hasHeader=false>
      <template #pickBox="{record}">
        <a @click="showPickBox(record)">查看</a>
      </template>
      <template #pkg="{ record }">
        {{ record.mainPkgList.join(',') }}
      </template>
      <template #action="{ record }">
        <a @click="print(record)">打印</a>
        <a @click="getDetail(record)"> 详情</a>
      </template>
      <template #expandedRender="{record}">
        <div>
          <a-table :columns="record.pickType == 0 ? taskGoodsColumns : taskGoodsColumns_delivery"
            :dataSource="record.pickType == 0 ? record.packPkgs : record.packAllotPkgs" :pagination="false">
            <div slot="img" slot-scope="text,record,index">
              <ImgPreviews :images="[record.productImg]"></ImgPreviews>
            </div>
          </a-table>
        </div>
      </template>
    </WmsTable>
    <el-dialog title="拣货任务详情" :visible.sync="dialogVisible">
      <detail ref="detail" @close="dialogVisible = false" @doPackFinish="getList"></detail>
    </el-dialog>
    <el-dialog title="分拣框" :visible.sync="pickBoxVisible">
      <div class="boxTitle">已组合：</div>
      <div class="boxBlock">
        <div class="boxItem" style="background-color: #048060;" v-for="(item, index) in pickData.filter(i=>i.combinableStatus == 1)" :key="item.basketCode">{{ item.basketCode }}</div>
      </div>
      <div class="boxTitle">组合中：</div>
      <div class="boxBlock">
        <div class="boxItem" style="background-color: #f79a39;" v-for="(item, index) in pickData.filter(i=>i.combinableStatus == 0)" :key="item.basketCode">{{ item.basketCode }}</div>
      </div>
    </el-dialog>
    <div class="startprint" ref="startprint">
      <el-table :data="printData" size="medium" :default-expand-all="true">
        <el-table-column type="expand" style="padding-lef: 50px">
          <template slot-scope="props">
            <el-table :data="props.row.pickType == 0 ? props.row.packPkgs : props.row.packAllotPkgs">
              <el-table-column label="批次包编码" prop="pkgCode"></el-table-column>
              <el-table-column label="商品sku" prop="shopProductSku"></el-table-column>
              <el-table-column label="规格" prop="productProp"></el-table-column>
              <el-table-column label="货格码" prop="gridCode"></el-table-column>
              <el-table-column label="数量" prop="useAmount" v-if="props.row.pickType == 0"></el-table-column>
              <el-table-column label="数量" prop="amount" v-else></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="任务单号" prop="pickCode"></el-table-column>
        <el-table-column label="任务状态" prop="status">
          <template slot-scope="props">
            <div>
              {{ props.row.pickType == 0 ? "组合任务" : props.row.pickType == 1 ? "调拨任务" : "" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="任务类型" prop="pickCode"></el-table-column>
        <el-table-column label="生成时间" prop="createTime"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import WmsTable from "@/components/WmsTable";
import ImgPreviews from "@/components/ImgPreviews";
import { taskColumns, taskGoodsColumns,taskGoodsColumns_delivery,taskColumns_delivery } from "./combinTable";
import { Table } from "ant-design-vue";
import { pcPickTaskPage, doPackFinish,getPackBasket } from "@/apis/combination";
import detail from "./taskListDetail";
export default {
  title: "任务列表",
  name: "taskList",
  components: {
    WmsTable,
    [Table.name]: Table,
    detail,
    ImgPreviews
  },
  data() {
    return {
      taskColumns,
      taskGoodsColumns,taskGoodsColumns_delivery,taskColumns_delivery,
      formInline: {
        pickType: 0
      },
      dataSource: [],
      dataSourceType: 0,
      params: {},
      query: {
        pageSize: 10,
        current: 0,
        total: 1,
      },
      dialogVisible: false,
      printData: [],

      pickBoxVisible: false,
      pickData:[]
    };
  },
  methods: {
    getList() {
      let params = {
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        ...this.formInline,
      };
      pcPickTaskPage(params).then(({ code, data }) => {
        if (code === 0) {
          data.records.forEach(item => {
            item.id = item.pickType == 0 ? item.packCode : item.pickCode
          })
          this.dataSource = data.records;
          this.dataSourceType = this.formInline.pickType
          this.query.total = data.total;
        }
      });
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getList();
    },
    onSubmit() {
      this.query.current = 1
      this.getList();
    },
    restSubmit() {
      this.formInline = {
        pickType: 0,
      };
      this.query = {
        pageSize: 10,
        current: 1,
        total: 1,
      };
      this.getList();
    },
    print(record) {
      this.printData = [record]
      this.$nextTick((_) => {
        let printDiv = this.$refs.startprint
        console.log(printDiv)
        let app = document.getElementById('app')
        app.style.opacity = 0
        printDiv.style['z-index'] = 9
        document.body.appendChild(printDiv);
        window.print();
        app.style.opacity = 1
        printDiv.style['z-index'] = -9
      });
    },
    getDetail(record) {
      console.log(record);
      this.dialogVisible = true
      this.$nextTick((_) => {
        this.$refs.detail.detail = record.packRecords;
      });
    },
    showPickBox(record){
      getPackBasket({packCode:record.packCode}).then(({code,data})=>{
        if(code == 0){
          this.pickData = data
          this.pickBoxVisible = true
        }
      })
    }
  },
  created() { },
};
</script>
<style lang="less" scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.startprint {
  position: fixed;
  top: 0;
  left: 0;
  z-index: -9;
  width: 800px;
}

.boxTitle{
  text-align: left;
}

.boxBlock{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.boxItem{
  height: 60px;
  padding: 0 20px;
  margin: 10px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  font-size: 30px;
}
</style>
